import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { DndProvider } from "react-dnd";
import { MultiBackend, getBackendOptions } from "@minoru/react-dnd-treeview";
import { CustomSnackbarProvider } from "./CustomSnackbarProvider"; // Import updated CustomSnackbarProvider
import { SnackbarProvider } from "notistack";
import store from './store';
import './index.css';
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import 'simplebar-react/dist/simplebar.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <SnackbarProvider maxSnack={5}>
        <DndProvider backend={MultiBackend} options={getBackendOptions()}>
          <CustomSnackbarProvider>
            <App />
          </CustomSnackbarProvider>
        </DndProvider>
      </SnackbarProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
